import { Injectable } from '@angular/core';

export interface Toast {
  header: string;
  icon?: string;
  body: string;
  className: string;
  delay?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: Toast[] = [];

  show(header: string, body: string, className: string, icon?: string, delay?: number) {
    this.toasts.push({
      header: header,
      icon: icon,
      body: body,
      className: className,
      delay: delay,
    });
  }

  success(header: string, body: string) {
    this.show(header, body, 'bg-secondary text-light', 'fa-solid fa-check');
  }

  error(header: string, body: string) {
    this.show(header, body, 'bg-danger text-light', 'fa-solid fa-triangle-exclamation', 7 * 24 * 60 * 60 * 1000);
  }

  remove(toast: Toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  removeAll() {
    this.toasts = [];
  }

}
